import { Company } from "../types";
import { CompetitorWithLogo } from "../../../types/competitor";

export const mapperInitBrandsData = (
  userId: string, 
  brand: Company, 
  competitors: CompetitorWithLogo[], 
  selectedCompetitors: CompetitorWithLogo[]
) => {
  const selectedCompetitorsNames = new Set(selectedCompetitors.map(c => c.name));

  return [{
    name: brand.name,
    website: brand.website,
    logo_url: brand.logoUrl,
    description: brand.description ?? "",
    region: brand.region ?? null,
    brand_type: brand.brandType ?? null,
    industry: brand.industry ?? null,
    primary_language: brand.primaryLanguage ?? 'English',
    target_audience: brand.targetAudience ?? null,
    competitor: false,
    is_active: true,
    user_id: userId,
  }, ...competitors.map(competitor => ({
    name: competitor.name,
    website: competitor.website,
    logo_url: competitor.logoUrl,
    description: competitor.description ?? "",
    region: null,
    brand_type: null,
    industry: null,
    primary_language: null,
    target_audience: null,
    competitor: true,
    is_active: selectedCompetitorsNames.has(competitor.name),
    user_id: userId,
  }))];
};
